export default {"src":"/_next/static/media/likeIcon.43db46ff.svg","height":18,"width":20};